<template>
<div>
    <p class="text-lg font-semibold text-center">Confirmation</p>
    <UDivider class="py-4"/>
    <div class="flex flex-col gap-4">
      <p>You can only purchase one gift card at a time. Would you like to replace the existing one and continue?</p>
      <!-- <p>Changing the delivery address requires a price update in the cart. Do you wish to proceed?</p> -->
    </div>
    <div class="inline-flex justify-between w-full p-5">
      <div class="">
        <UButton size="xl" label="Close" variant="outline" block @click="emit('close')"/>
      </div>
      <div class="">
        <UButton size="xl" label="Proceed" block @click="emit('success')"/>
      </div>
    </div>
</div>

</template>
<script setup>
const emit = defineEmits(['close','success']);
</script>